export default function (state = null, action) {

    if (action.type === 'WIDGET_PROMOTIE') {
        
        state = {
            ...action.payload,
            newLeaderboard: action.payload.newLeaderboard,
            prevLeaderboard: action.payload.prevLeaderboard,
        }
    }
    // let result = {
    //     "timestamp": "2020-03-10 18:51:02",
    //     'position': '100+',
    //     'username': "testloto2017",
    //     'points': 6,
    //     'prize': null,
    //     "results": [
    //         {
    //             "nr. crt.": 1,
    //             "username": "31**324",
    //             "points": 1849,
    //             "prize": 7000
    //         },
    //         {
    //             "nr. crt.": 2,
    //             "username": "31**526",
    //             "points": 1042,
    //             "prize": 5000
    //         },
    //         {
    //             "nr. crt.": 3,
    //             "username": "12**121",
    //             "points": 607,
    //             "prize": 3000
    //         },
    //         {
    //             "nr. crt.": 4,
    //             "username": "testlo**017OLD",
    //             "points": 500,
    //             "prize": 900
    //         },
    //         {
    //             "nr. crt.": 5,
    //             "username": "38**842",
    //             "points": 406,
    //             "prize": 1000
    //         },
    //         {
    //             "nr. crt.": 6,
    //             "username": "12**097",
    //             "points": 399,
    //             "prize": 1000
    //         },
    //         {
    //             "nr. crt.": 7,
    //             "username": "14**462",
    //             "points": 367,
    //             "prize": 1000
    //         },
    //         {
    //             "nr. crt.": 8,
    //             "username": "36**77",
    //             "points": 238,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 9,
    //             "username": "31**300",
    //             "points": 214,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 10,
    //             "username": "12**872",
    //             "points": 212,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 11,
    //             "username": "38**586",
    //             "points": 204,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 12,
    //             "username": "37**561",
    //             "points": 179,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 13,
    //             "username": "29**827",
    //             "points": 167,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 14,
    //             "username": "17**731",
    //             "points": 147,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 15,
    //             "username": "38**822",
    //             "points": 136,
    //             "prize": 500
    //         },
    //         {
    //             "nr. crt.": 16,
    //             "username": "10**450",
    //             "points": 119,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 17,
    //             "username": "38**621",
    //             "points": 111,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 18,
    //             "username": "12**921",
    //             "points": 105,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 19,
    //             "username": "31**494",
    //             "points": 104,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 20,
    //             "username": "16**185",
    //             "points": 94,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 21,
    //             "username": "14**605",
    //             "points": 92,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 22,
    //             "username": "13**090",
    //             "points": 85,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 23,
    //             "username": "37**703",
    //             "points": 83,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 24,
    //             "username": "31**496",
    //             "points": 79,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 25,
    //             "username": "15**673",
    //             "points": 73,
    //             "prize": 300
    //         },
    //         {
    //             "nr. crt.": 26,
    //             "username": "13**098",
    //             "points": 72,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 27,
    //             "username": "31**442",
    //             "points": 68,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 28,
    //             "username": "36**896",
    //             "points": 66,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 29,
    //             "username": "13**775",
    //             "points": 65,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 30,
    //             "username": "28**740",
    //             "points": 64,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 31,
    //             "username": "38**928",
    //             "points": 62,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 32,
    //             "username": "13**813",
    //             "points": 60,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 33,
    //             "username": "12**553",
    //             "points": 58,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 34,
    //             "username": "38**869",
    //             "points": 51,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 35,
    //             "username": "14**520",
    //             "points": 51,
    //             "prize": 200
    //         },
    //         {
    //             "nr. crt.": 36,
    //             "username": "12**659",
    //             "points": 50,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 37,
    //             "username": "35**582",
    //             "points": 49,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 38,
    //             "username": "38**113",
    //             "points": 47,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 39,
    //             "username": "10**929",
    //             "points": 46,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 40,
    //             "username": "38**713",
    //             "points": 45,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 41,
    //             "username": "29**519",
    //             "points": 43,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 42,
    //             "username": "16**902",
    //             "points": 40,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 43,
    //             "username": "32**696",
    //             "points": 40,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 44,
    //             "username": "13**735",
    //             "points": 40,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 45,
    //             "username": "38**969",
    //             "points": 40,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 46,
    //             "username": "10**722",
    //             "points": 39,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 47,
    //             "username": "38**101",
    //             "points": 39,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 48,
    //             "username": "17**120",
    //             "points": 34,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 49,
    //             "username": "38**781",
    //             "points": 33,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 50,
    //             "username": "36**320",
    //             "points": 31,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 51,
    //             "username": "37**061",
    //             "points": 31,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 52,
    //             "username": "38**553",
    //             "points": 31,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 53,
    //             "username": "38**638",
    //             "points": 30,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 54,
    //             "username": "13**106",
    //             "points": 30,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 55,
    //             "username": "38**020",
    //             "points": 28,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 56,
    //             "username": "33**394",
    //             "points": 28,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 57,
    //             "username": "38**408",
    //             "points": 24,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 58,
    //             "username": "38**343",
    //             "points": 22,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 59,
    //             "username": "36**963",
    //             "points": 21,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 60,
    //             "username": "38**432",
    //             "points": 20,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 61,
    //             "username": "33**509",
    //             "points": 20,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 62,
    //             "username": "38**679",
    //             "points": 19,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 63,
    //             "username": "33**329",
    //             "points": 19,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 64,
    //             "username": "38**577",
    //             "points": 18,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 65,
    //             "username": "36**653",
    //             "points": 17,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 66,
    //             "username": "10**633",
    //             "points": 17,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 67,
    //             "username": "34**05",
    //             "points": 17,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 68,
    //             "username": "31**070",
    //             "points": 17,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 69,
    //             "username": "38**289",
    //             "points": 17,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 70,
    //             "username": "11**628",
    //             "points": 15,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 71,
    //             "username": "36**595",
    //             "points": 15,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 72,
    //             "username": "30**101",
    //             "points": 14,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 73,
    //             "username": "29**119",
    //             "points": 14,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 74,
    //             "username": "36**214",
    //             "points": 14,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 75,
    //             "username": "28**273",
    //             "points": 13,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 76,
    //             "username": "34**152",
    //             "points": 13,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 77,
    //             "username": "17**933",
    //             "points": 13,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 78,
    //             "username": "30**359",
    //             "points": 13,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 79,
    //             "username": "38**716",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 80,
    //             "username": "36**352",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 81,
    //             "username": "36**368",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 82,
    //             "username": "14**547",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 83,
    //             "username": "29**936",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 84,
    //             "username": "38**202",
    //             "points": 12,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 85,
    //             "username": "38**481",
    //             "points": 11,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 86,
    //             "username": "38**781",
    //             "points": 11,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 87,
    //             "username": "38**138",
    //             "points": 11,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 88,
    //             "username": "21**54",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 89,
    //             "username": "14**574",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 90,
    //             "username": "14**060",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 91,
    //             "username": "38**013",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 92,
    //             "username": "38**326",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 93,
    //             "username": "13**55",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 94,
    //             "username": "12**861",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 95,
    //             "username": "14**322",
    //             "points": 9,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 96,
    //             "username": "38**149",
    //             "points": 8,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 97,
    //             "username": "36**205",
    //             "points": 8,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 98,
    //             "username": "37**724",
    //             "points": 8,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 99,
    //             "username": "31**106",
    //             "points": 8,
    //             "prize": "-"
    //         },
    //         {
    //             "nr. crt.": 100,
    //             "username": "38**220",
    //             "points": 7,
    //             "prize": "-"
    //         }
    //     ]
    // }
    // state = {
    //     newLeaderboard: result.results,
    //     prevLeaderboard: result.results,
    //     newUser: {
    //         'position': '100+',
    //         'username': "testloto2017",
    //         'points': 5,
    //         'prize': null,
    //     },
    //     prevUser: {
    //         'position': '100+',
    //         'username': "testloto2017",
    //         'points': 4,
    //         'prize': null,
    //     }
    // }
    // console.log('state', state);
    return state;

}